import { useMutation, useQueryClient } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';
import { SuccessToast, ErrorToast } from 'services/toasterService';

export default function useAddEmployee(closeModal, reset) {
  const queryClient = useQueryClient();
  return useMutation(
    async (data) => {
      const response = await makeApiRequest.post(
        apiEndPoints.TEAM_MEMBERS_API,
        data
      );
      return response?.data;
    },
    {
      onSuccess: (data) => {
        closeModal();
        reset({});
        SuccessToast({ text: data?.message });
        queryClient.invalidateQueries('get-all-team-members');
        queryClient.invalidateQueries('get-all-employees-data');
      },
      onError: (error) => {
        ErrorToast({ text: error.response.data.message });
      },
    }
  );
}
